import { useGet } from '../../useApi';

export interface CommissionRate {
  service_id: string;
  meter_class: string;
  rate_pct: string;
  cap: string | null;
}

export interface CommissionRates {
  current: CommissionRate[];
  history: (CommissionRate & { effective_from: string; changed_by: string; reason: string | null })[];
}

// What a change would do (POST /admin/commission-rates/preview, pricing P9).
export interface CommissionPreview {
  service_id: string;
  meter_class: string;
  current: { rate_pct: string; cap: string | null } | null;
  proposed: { rate_pct: string; cap: string | null };
  large: boolean;
  warnings: string[];
  impact: { amount: string; before: string | null; after: string | null }[];
}

// GET /admin/commission-rates (D13a). Changes go through CommissionRatesCard,
// which previews them and saves with a fresh passkey check.
const useCommissionRates = () => {
  const { data, loading, fetch, setData } = useGet<CommissionRates>('Failed to load commission rates');
  return { rates: data, loading, setRates: setData, fetchRates: () => fetch('api/v1/admin/commission-rates') };
};

export default useCommissionRates;
